import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  const prevPathnameRef = useRef();

  useEffect(() => {
    // Set scroll restoration to manual on mount
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    // Only scroll if pathname actually changed (not just query params)
    if (prevPathnameRef.current !== pathname) {
      // Log for debugging on Vercel
      console.log('[ScrollToTop] Route changed from', prevPathnameRef.current, 'to', pathname);
      
      // Multiple strategies to ensure scroll happens
      // Strategy 1: Immediate scroll
      window.scrollTo(0, 0);
      
      // Strategy 2: ScrollTo with options
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      
      // Strategy 3: Direct DOM manipulation as fallback
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }
      if (document.body) {
        document.body.scrollTop = 0;
      }
      
      // Strategy 4: Delayed scroll for React Router v7 timing issues
      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
        console.log('[ScrollToTop] Executed scroll after RAF');
      });
      
      // Strategy 5: Final fallback with setTimeout
      setTimeout(() => {
        window.scrollTo(0, 0);
        console.log('[ScrollToTop] Executed scroll after timeout');
      }, 10);
    }
    
    prevPathnameRef.current = pathname;
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
